import useDetectIsMobile from '../../../hook/use-detect-is-mobile';
import React, { useState } from 'react';
import useGet from '../../../hook/use-get';
import { API } from '../../../helpers/constants';
import { SectionError } from '../../../components/error';
import Slider from '../../../components/slider';

const BannerContent = () => {
  const { isMobile } = useDetectIsMobile();
  const [banners, setBanners] = useState([]);
  const {
    isFetching: isFetching,
    isError,
    refetch
  } = useGet({
    queryKey: 'bannerAngkutan',
    api: API.transportBanners,
    options: {
      onSuccess: (res) => {
        setBanners([isMobile ? res?.data?.['file_url_potrait'] : res?.data?.['file_url']]);
      }
    }
  });

  if (isFetching) {
    return <div className="w-full h-96 bg-gray-300 animate-pulse" />;
  }

  if (isError) {
    return (
      <div className="h-80 items-center justify-center flex border border-b rounded-lg">
        <SectionError refetch={refetch} />
      </div>
    );
  }

  return <Slider contents={banners} isArrowRounded />;
};

export default BannerContent;
